/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherThermometerIcon16Solid = forwardRef('WeatherThermometerIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3.5a3 3 0 0 1 6 0v4.146a4.5 4.5 0 1 1-6 0V3.5Zm3 1.125c.483 0 .875.392.875.875v3.563a2.125 2.125 0 1 1-1.75 0V5.5c0-.483.392-.875.875-.875Z" })));
});
